export default __webpack_public_path__ + "locales/nl/Settings.json?hash=88234cb72062bf989c4e6b37590dacc6";